export default __webpack_public_path__ + "static/O0249-a9621e5e2b6ae7385c74d4a5dc53c29e.png";